import type {
  InspectAssessmentInstrument,
  InspectAssessmentNews,
} from '../../../../state/app/inspect_assessment/types';

export const ICS_HELP_TEXT =
  'ICS (individual conviction score) is a signed impact value for each news-item/instrument pair: how strongly and in which direction that news is expected to affect that instrument. Pillar 1 treats an instrument as materially affected when |ICS| is at least 0.25.';

export type IcsDescription = {
  text: string;
  tone: 'missing' | 'neutral' | 'positive' | 'negative';
  value?: number;
};

export const describeIcs = (
  news: InspectAssessmentNews,
  instrument?: InspectAssessmentInstrument,
): IcsDescription => {
  if (!instrument) {
    return { text: 'ICS —', tone: 'missing' };
  }
  if (news.mapping_status === 'assessment_period_missing') {
    return {
      text: 'ICS —',
      tone: 'missing',
    };
  }
  if (news.mapping_status === 'ambiguous') {
    return {
      text: 'ICS —',
      tone: 'missing',
    };
  }
  if (news.mapping_status === 'unmapped' || !news.benchmark_news_score) {
    return {
      text: 'ICS —',
      tone: 'missing',
    };
  }
  if (instrument.ics_source === 'none' || !instrument.ics_code) {
    return {
      text: 'ICS —',
      tone: 'missing',
    };
  }

  const rawValue = news.benchmark_news_score.ics?.[instrument.ics_code];
  if (typeof rawValue !== 'number' || !Number.isFinite(rawValue)) {
    return {
      text: 'ICS —',
      tone: 'missing',
    };
  }

  const sign = rawValue > 0 ? '+' : '';
  return {
    text: `ICS ${sign}${rawValue.toFixed(2)}`,
    tone:
      Math.abs(rawValue) < 0.25
        ? 'neutral'
        : rawValue > 0
          ? 'positive'
          : 'negative',
    value: rawValue,
  };
};
